import { useLayoutEffect } from 'react';
import { insertElementsToHTMLBanner } from './insertElementsToHTMLBanner';
export function useHTMLBannerInserts(_ref) {
  var eventEmitter = _ref.eventEmitter,
    containerId = _ref.containerId;
  useLayoutEffect(function () {
    var removeElementsFromHTMLBanner = null;
    var adFoxBannerOnLoadData = null;
    var unsubscribe = eventEmitter.subscribe(function (data) {
      var _adFoxBannerOnLoadDat;
      switch (data.event) {
        case 'load':
          adFoxBannerOnLoadData = data.data;
          break;
        case 'render':
          if ((_adFoxBannerOnLoadDat = adFoxBannerOnLoadData) !== null && _adFoxBannerOnLoadDat !== void 0 && _adFoxBannerOnLoadDat.bundleParams && adFoxBannerOnLoadData.bundleName === 'banner.interscroller') {
            removeElementsFromHTMLBanner = insertElementsToHTMLBanner(adFoxBannerOnLoadData.bundleParams, containerId);
          }
          unsubscribe();
          break;
        case 'stub':
        case 'error':
          unsubscribe();
          break;
      }
    });
    return function () {
      var _removeElementsFromHT;
      (_removeElementsFromHT = removeElementsFromHTMLBanner) === null || _removeElementsFromHT === void 0 || _removeElementsFromHT();
      unsubscribe();
    };
  }, []);
}